import { TypedContainer } from "./_Base";
export class AudioContainer extends TypedContainer {
  setContent(content) {
    super.set_content(content);
  }
  setAudioBuilder(audioBuilder) {
    return this.set_content(audioBuilder);
  }
  audioBuilder() {
    return this.content();
  }
  coreContentCloned() {
    if (this._content) {
      return this._content.clone();
    }
  }
}
